import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/Dialog';
import { Button } from '@/components/ui/Button';
import { CheckCircle2, XCircle, Mail } from 'lucide-react';

interface EmailResultDialogProps {
  open: boolean;
  onClose: () => void;
  emailSent: boolean;
  emailError?: string | null;
  userEmail: string;
}

export const EmailResultDialog: React.FC<EmailResultDialogProps> = ({
  open,
  onClose,
  emailSent,
  emailError,
  userEmail,
}) => {
  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-[500px]" onClose={onClose}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {emailSent ? (
              <>
                <CheckCircle2 className="h-5 w-5 text-green-500" />
                승인 완료
              </>
            ) : (
              <>
                <XCircle className="h-5 w-5 text-red-500" />
                승인 완료 (이메일 발송 실패)
              </>
            )}
          </DialogTitle>
          <DialogDescription className="whitespace-pre-line text-base mt-2">
            {emailSent ? (
              <>
                사용자가 성공적으로 승인되었습니다.\n\n
                <div className="mt-3 flex items-center gap-2 text-green-600">
                  <Mail className="h-4 w-4" />
                  <span className="font-medium">승인 완료 이메일이 {userEmail}로 발송되었습니다.</span>
                </div>
              </>
            ) : (
              <>
                사용자가 성공적으로 승인되었습니다.\n\n
                <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                  <div className="flex items-start gap-2 text-yellow-800">
                    <XCircle className="h-4 w-4 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="font-medium mb-1">⚠️ 승인 완료 이메일 발송에 실패했습니다.</p>
                      {emailError && (
                        <p className="text-sm text-yellow-700 mt-1">{emailError}</p>
                      )}
                      <p className="text-sm text-yellow-700 mt-2">
                        사용자는 승인되었지만 이메일을 받지 못했습니다.\n
                        SMTP 설정을 확인하거나 수동으로 사용자에게 승인 완료를 알려주세요.
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={onClose}>
            확인
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

